<p-tag [severity]="severity()" [value]="('measurement.liveness.' + liveness()) | translate"></p-tag>
